import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Button, Text } from '@chakra-ui/react';
import { RiScreenshot2Line } from 'react-icons/ri';
import { useMapContext } from '../../contexts/MapContext';
import { downloadMapImage, handleDownloadResponse } from '../../utilities/downloadMapImage';

export default function MapImageDownloadButton() {
    const { data, isLoading } = useSelector((state) => state.media);
    const { user } = useSelector((state) => state.auth);
    const dispatch = useDispatch();
    const { map } = useMapContext();

    useEffect(() => {
        handleDownloadResponse(data);
    }, [data]);

    return (
        <>
            <Box
                style={{ position: 'absolute', zIndex: 999, marginTop: '50px', marginLeft: '12px' }}
            >
                <Button
                    onClick={() => downloadMapImage(map, user, dispatch, { enableWatermark: true })}
                    isLoading={isLoading}
                    variant='outline'
                    rightIcon={<RiScreenshot2Line />}
                    size='sm'
                >
                    Save/share
                </Button>
                {isLoading && (
                    <Text fontSize='xs' style={{ marginTop: '5px' }}>
                        Generating screenshot (this may take up to 10 seconds)
                    </Text>
                )}
            </Box>
        </>
    );
}
